import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Spin, message } from "antd";
import { RULES_ANTD } from "../../../constants";
import { Link, useHistory } from "react-router-dom";
import Order from "../../../api/orderApi";
const FormForgotPass = () => {
  const [loading, setLoading] = useState(false);
  // const [EmailSuccess, setEmailSuccess] = useState(false);
  const [form] = Form.useForm();
  const [number, setNumber] = useState(30);

  const timerIdRef = useRef(0);

  useEffect(() => {
    if (number === 0) {
      stopHandler();
    }
  });

  useEffect(() => {
    () => {};
    return () => {
      stopHandler();
    };
  }, []);
  const stopHandler = () => {
    console.log("a");
    clearInterval(timerIdRef.current);
    timerIdRef.current = 30;
    setNumber(30);
    setLoading(false);
  };

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    // neu k co loading thì nó sẽ set interval liên tục
    // if (timerIdRef.current) {
    //   return;
    // }
    const data = { phone_number: value.AMV_forgot_phone || "" };
    const res = await Order.ResetPassword(data);
    if (res && res.meta && res.meta.statusCode === 200) {
      // setLoading(false);
      message.success(
        "Đã gửi mật khẩu qua mail bạn đăng kí bằng điện thoại thành công, nếu chưa nhận được xin vui lòng thử lại" ||
          ""
      );
    } else {
      // setLoading(false);
      message.error("Tài khoản email không tồn tại" || "");
    }

    timerIdRef.current = setInterval(() => setNumber((c) => c - 1), 1000);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Bạn chưa nhập đầy đủ thông tin");
    return;
  };
  return (
    <div>
      {/* {loading && <LoadingConfig title="" />} */}
      <Form
        className="RegisterUserForm"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <div className="content__content--one row">
          {/* <!-- name --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Điện thoại đăng ký"
              name="AMV_forgot_phone"
              hasFeedback
              rules={RULES_ANTD.phone}
            >
              <Input placeholder="Điện thoại bạn đăng kí (*)" />
            </Form.Item>
          </div>
          <div className="col-md-6 col-sm-12"></div>
          <div className="col-md-12 col-sm-12 note">
            {loading
              ? "Nếu bạn chưa nhận được mail, chờ 30 giây để gửi lại"
              : ""}
          </div>

          <div className="col-12" className="btn-bottom">
            <Button
              type="primary"
              shape="round"
              htmlType="submit"
              className="btn sentGmail   mb-4"
              loading={loading}
            >
              Gửi mail
            </Button>
            <Link to="/login">
              <Button
                // type="primary"
                htmlType="button"
                type="default"
                shape="round"
                className="btn toLogin   mb-4"
              >
                Trở về đăng nhập
              </Button>
            </Link>
            <div className="time">{loading ? number : ""}</div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default FormForgotPass;
